import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { API_PATHS, API_QUERY_PARAMS } from '../constants/api-paths';
import {
  BienDocumentAchat,
  DocumentAchatType,
  DocumentAchatUploadParams,
} from '../models/document-achat.model';

/**
 * Client HTTP des documents d'achat d'un bien
 * ({@code /biens/{id}/documents-achat}).
 */
@Injectable({
  providedIn: 'root',
})
export class DocumentAchatService {
  constructor(private readonly http: HttpClient) {}

  /** Liste les documents actifs ; filtre optionnel par type. */
  list(
    bienId: string,
    type?: DocumentAchatType
  ): Observable<BienDocumentAchat[]> {
    let params = new HttpParams();
    if (type) {
      params = params.set(API_QUERY_PARAMS.type, type);
    }
    return this.http.get<BienDocumentAchat[]>(
      `${environment.apiUrl}${API_PATHS.bienDocumentsAchat(bienId)}`,
      { params }
    );
  }

  /** Métadonnées d'un document actif. */
  findById(bienId: string, documentId: string): Observable<BienDocumentAchat> {
    return this.http.get<BienDocumentAchat>(
      `${environment.apiUrl}${API_PATHS.bienDocumentAchat(bienId, documentId)}`
    );
  }

  /** Upload multipart (fichier + type / date optionnelle). */
  upload(
    bienId: string,
    params: DocumentAchatUploadParams
  ): Observable<BienDocumentAchat> {
    const formData = new FormData();
    formData.append('file', params.file, params.file.name);

    let httpParams = new HttpParams().set('type', params.type);
    if (params.dateDocument) {
      httpParams = httpParams.set('dateDocument', params.dateDocument);
    }

    return this.http.post<BienDocumentAchat>(
      `${environment.apiUrl}${API_PATHS.bienDocumentsAchat(bienId)}`,
      formData,
      { params: httpParams }
    );
  }

  /** Contenu binaire du fichier stocké. */
  download(bienId: string, documentId: string): Observable<Blob> {
    return this.http.get(
      `${environment.apiUrl}${API_PATHS.bienDocumentAchatFichier(
        bienId,
        documentId
      )}`,
      { responseType: 'blob' }
    );
  }

  /** Suppression côté API (métadonnées + stockage). */
  delete(bienId: string, documentId: string): Observable<void> {
    return this.http.delete<void>(
      `${environment.apiUrl}${API_PATHS.bienDocumentAchat(bienId, documentId)}`
    );
  }
}
